import input from '@/components/input'

export default {
  name: 'maInputNumber',
  extends: input,
  props: {
    icon: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    removeIcon: {
      type: Boolean,
      required: false,
      default: false
    },
    min: {
      type: Number,
      required: false
    },
    max: {
      type: Number,
      required: false
    },
    step: {
      type: Number,
      required: false,
      default: 1
    }
  },
  computed: {
    showRemoveIcon() {
      return this.removeIcon && this.value && this.value.toString().length > 0
    }
  },
  watch: {
    disabled(newVal) {
      if (newVal) this.$emit('input', null)
    },
    value(newVal) {
      let value = parseFloat(newVal)

      if (isNaN(value)) {
        value = null
      } else if (this.min != null && value < this.min) {
        value = this.min
      } else if (this.max != null && value > this.max) {
        value = this.max
      }

      if (value !== newVal) {
        this.$emit('input', value)
      }
    }
  }
}
